"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getUserDataByUsername = exports.getImageForUserName = exports.getGlobalRankingData = exports.getStructureData = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _UserManagementService = _interopRequireDefault(require("../common/components/Equizzer/services/UserManagementService"));

var _ArrayHelper = require("./ArrayHelper");

// noinspection Eslint
// eslint-disable-line
var getStructureData = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var activated, structureData, newData, myData, summedUnits, userPictureMD5s, getUnits;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            activated = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED);

            if (!(activated === true)) {
              _context.next = 17;
              break;
            }

            _context.next = 4;
            return _UserManagementService["default"].getStructureData();

          case 4:
            structureData = _context.sent;
            newData = {};
            myData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.ERGO_USER_DATA);
            summedUnits = [];
            userPictureMD5s = [];

            getUnits = function getUnits(user) {
              if (user.pnr !== myData.pnr) {
                user.structureUnits.forEach(function (unitObj) {
                  summedUnits.push(unitObj);
                });
              }

              if (user.pictureMd5) {
                userPictureMD5s.push({
                  username: user.username,
                  pictureMd5: user.pictureMd5
                });
              }

              if (user.siblings) {
                user.siblings.forEach(function (sibling) {
                  if (sibling.pictureMd5) {
                    userPictureMD5s.push({
                      username: sibling.username,
                      pictureMd5: sibling.pictureMd5
                    });
                  }
                });
              }

              user.subs.forEach(function (subUser) {
                getUnits(subUser);
              });
            };

            getUnits(structureData.user);
            newData[_DataStore.DATA_STORE_PATHS.ERGO_SUMMED_STRUCTURE_UNITS] = summedUnits;
            newData[_DataStore.DATA_STORE_PATHS.ERGO_STRUCTURE_DATA] = structureData;
            _context.next = 15;
            return _DataStore["default"].setData(newData);

          case 15:
            checkForNewImages(userPictureMD5s);
            return _context.abrupt("return", structureData);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getStructureData() {
    return _ref.apply(this, arguments);
  };
}();

exports.getStructureData = getStructureData;

var getGlobalRankingData = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var rankingData, userPictureMD5s;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _UserManagementService["default"].getGlobalRanking();

          case 2:
            rankingData = _context2.sent;
            userPictureMD5s = [];
            rankingData.users.forEach(function (user) {
              if (user.pictureMd5) {
                userPictureMD5s.push({
                  username: user.username,
                  pictureMd5: user.pictureMd5
                });
              }
            });
            checkForNewImages(userPictureMD5s);
            return _context2.abrupt("return", rankingData);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getGlobalRankingData() {
    return _ref2.apply(this, arguments);
  };
}();

exports.getGlobalRankingData = getGlobalRankingData;

var checkForNewImages = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(userPictures) {
    var localPictures, userNamesToFetch, oldImagesToRemove;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.ERGO_USER_PICTURES);

          case 2:
            _context3.t0 = _context3.sent;

            if (_context3.t0) {
              _context3.next = 5;
              break;
            }

            _context3.t0 = [];

          case 5:
            localPictures = _context3.t0;
            userNamesToFetch = [];
            oldImagesToRemove = [];
            userPictures.forEach(function (user) {
              var localUserImage = localPictures.find(function (localUser) {
                return localUser.username === user.username;
              });

              if (localUserImage) {
                if (localUserImage.pictureMd5 !== user.pictureMd5) {
                  console.log("".concat(user.username, " hat ein neues Bild -> neu holen"));
                  userNamesToFetch.push(user.username);
                  oldImagesToRemove.push(user.username);
                } else {
                  console.log("".concat(user.username, " hat ein neues Bild, aber es ist bereits lokal vorhanden"));
                }
              } else {
                console.log("Es gibt f\xFCr ".concat(user.username, " kein lokales Bild -> neu holen"));
                userNamesToFetch.push(user.username);
              }
            });
            oldImagesToRemove.forEach(function (user) {
              var index = localPictures.findIndex(function (localUser) {
                return localUser.username === user.username;
              });

              if (index > -1) {
                (0, _ArrayHelper.removeElementAtPosition)(localPictures, index);
              }
            });
            _context3.next = 12;
            return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.ERGO_USER_PICTURES, localPictures);

          case 12:
            if (userNamesToFetch.length > 0) {
              fetchNewImages(userNamesToFetch);
            }

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function checkForNewImages(_x) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchNewImages = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(userNames) {
    var userPictures, localPictures;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _UserManagementService["default"].getUserPictures(userNames);

          case 2:
            userPictures = _context4.sent;
            _context4.next = 5;
            return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.ERGO_USER_PICTURES);

          case 5:
            _context4.t0 = _context4.sent;

            if (_context4.t0) {
              _context4.next = 8;
              break;
            }

            _context4.t0 = [];

          case 8:
            localPictures = _context4.t0;

            if (userPictures) {
              userPictures.forEach(function (picture) {
                localPictures.push(picture);
              });
            }

            _context4.next = 12;
            return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.ERGO_USER_PICTURES, localPictures);

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchNewImages(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var getImageForUserName = function getImageForUserName(username) {
  var localPictures = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.ERGO_USER_PICTURES) || [];
  var index = localPictures.findIndex(function (localUser) {
    return localUser.username === username;
  });

  if (index > -1) {
    return localPictures[index];
  }

  return null;
};

exports.getImageForUserName = getImageForUserName;

var getUserDataByUsername = function getUserDataByUsername(username) {
  var structureData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.ERGO_STRUCTURE_DATA) || [];
  var userToReturn = null;

  var isUser = function isUser(user) {
    if (user.username === username) {
      userToReturn = user;
    } else {
      if (user.subs && user.subs.length > 0) {
        user.subs.forEach(function (subUser) {
          isUser(subUser);
        });
      }

      if (user.siblings && user.siblings.length > 0) {
        user.siblings.forEach(function (sibling) {
          isUser(sibling);
        });
      }

      if (user.parent) {
        isUser(user.parent);
      }
    }
  };

  isUser(structureData.user);
  return userToReturn;
};

exports.getUserDataByUsername = getUserDataByUsername;